import {
  border2,
  rem,
  radius,
  token,
  spacing,
  text,
} from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const styles = [
  css`
    :host {
      display: flex;
      flex-direction: column;
      position: relative;

      .small {
        font-size: ${rem(12)};
      }
    }

    :where(.select-content[variant='button']) {
      border: unset;
      border-radius: ${radius('medium')};
      box-shadow: ${token('elevation-shadow-raised')};

      ::slotted(a-select-option) {
        --option-checkmark-spacing: ${spacing(100)};
      }
    }

    :where(.select-content[variant='default']) {
      border-radius: ${radius('small')};
      box-shadow: 0 ${rem(2, 8)} hsl(240 3.8% 46.1% / 0.12);

      ::slotted(a-select-option:not(:last-child)) {
        border-block-end: ${border2(1, 'input-border-default')};
      }
    }

    :where(.select-content) {
      border: ${border2(1, 'input-border-default')};
      margin: unset;
      max-block-size: var(--auto-size-available-height);
      max-inline-size: var(--auto-size-available-width);
      overflow: hidden;
      overflow-y: auto;
      padding: unset;

      ::slotted(a-select-option) {
        inline-size: var(--auto-size-available-width);
      }
    }

    :where(.select-header[variant='button']) {
      background: ${token('background-tertiary')};
      block-size: ${rem(38)};
      border-radius: ${radius('medium')};
      box-shadow: ${token('elevation-shadow-raised')};
      gap: ${spacing(75)};
      padding-inline-end: ${spacing(200)};
      padding-inline-start: ${spacing(200)};

      &:hover {
        background: ${token('input-background-hover')};
      }

      :where(a-icon) {
        color: ${token('text-primary')};
      }

      .container {
        max-inline-size: calc(100% - ${rem(12)} - var(--tm-spacing-space-75));
      }

      .container-value {
        inline-size: 100%;

        span {
          color: ${token('text-primary')};
          /* @ include font size refuses to work here */
          font-size: ${rem(16)};
          inline-size: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          @include ${text('nav', 'medium', 'semi-bold')};
        }
      }
    }

    :where(.select-header[variant='default']) {
      background: ${token('background-secondary')};
      border: ${border2(1, 'border-strong')};
      border-radius: ${radius('small')};
      gap: ${spacing(100)};
      padding: ${spacing(150)};

      :where(a-icon) {
        color: ${token('foreground-interactive')};
      }
    }

    :where(.select-header) {
      align-items: center;
      cursor: pointer;
      display: flex;
      min-inline-size: 0;
      user-select: none;

      &:hover {
        border-color: ${token('input-border-focus')};
      }

      :where(a-icon) {
        flex: 0 0 auto;
        margin-inline-start: auto;
      }
    }

    :where(.select-header.default-text) {
      color: ${token('text-secondary')};
    }

    :host([disabled]) {
      :where(.select-header) {
        background: ${token('input-background-disabled')};
        border: ${border2(1, 'border-disabled')};
        color: ${token('input-foreground-disabled')};
        cursor: not-allowed;

        :where(a-icon) {
          color: ${token('input-foreground-disabled')};
        }
      }

      :where(.container-value img) {
        filter: grayscale(100%);
        opacity: 0.5;
      }
    }

    :where(.container-value) {
      align-items: center;
      display: flex;
      gap: ${spacing(250)};
      min-block-size: 1.5em;
      min-inline-size: 0;

      .selected-content {
        display: block;
        flex: 1 1 auto;
        min-inline-size: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      img {
        block-size: ${rem(55)};
        inline-size: ${rem(55)};
        object-fit: contain;

        &:not([src*='http']) {
          display: none;
        }
      }
    }

    :where(.container-value.input-focused) {
      color: ${token('text-disabled')};
    }

    :where(.container-value.input-focused img),
    :where(.container-value.input-focused a-icon) {
      opacity: 0.5;
    }

    :where(input) {
      background: transparent;
      border: unset;
      font-size: inherit;
      outline: none;
      position: absolute;
      transform: translateX(${rem(-3)});
    }

    :where(.container) {
      align-items: center;
      display: flex;
      flex: 1 1 auto;
      min-inline-size: 0;
    }

    .hidden {
      visibility: hidden;
    }
  `,
];
